import { Center, Loader } from '@mantine/core';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { ActFormPage } from './pages/ActFormPage';
import { ActPrintPage } from './pages/ActPrintPage';
import { ActsPage } from './pages/ActsPage';
import { CounterpartiesPage } from './pages/CounterpartiesPage';
import { DashboardPage } from './pages/DashboardPage';
import { DocflowPage } from './pages/DocflowPage';
import { EmployeesPage } from './pages/EmployeesPage';
import { EstimateFormPage } from './pages/EstimateFormPage';
import { EstimatePrintPage } from './pages/EstimatePrintPage';
import { EstimatesPage } from './pages/EstimatesPage';
import { IncomingUpdFormPage } from './pages/IncomingUpdFormPage';
import { InvoiceFormPage } from './pages/InvoiceFormPage';
import { InvoicePrintPage } from './pages/InvoicePrintPage';
import { InvoicesPage } from './pages/InvoicesPage';
import { LoginPage } from './pages/LoginPage';
import { NomenclaturePage } from './pages/NomenclaturePage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { PowerOfAttorneyFormPage } from './pages/PowerOfAttorneyFormPage';
import { PowerOfAttorneyPrintPage } from './pages/PowerOfAttorneyPrintPage';
import { PowersOfAttorneyPage } from './pages/PowersOfAttorneyPage';
import { PriceListPage } from './pages/PriceListPage';
import { UpdFormPage } from './pages/UpdFormPage';
import { UpdPrintPage } from './pages/UpdPrintPage';

function AppRoutes() {
  const { user, initializing } = useAuth();

  // Пока восстанавливаем сессию, не показываем ни форму входа, ни приложение —
  // иначе при каждой перезагрузке страницы мелькал бы экран логина
  if (initializing) {
    return (
      <Center mih="100vh">
        <Loader />
      </Center>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/counterparties" element={<CounterpartiesPage />} />
        <Route path="/nomenclature" element={<NomenclaturePage />} />
        <Route path="/price-list" element={<PriceListPage />} />
        <Route path="/employees" element={<EmployeesPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/invoices/:id" element={<InvoiceFormPage />} />
        <Route path="/upd" element={<DocflowPage />} />
        <Route path="/upd/:id" element={<UpdFormPage />} />
        <Route path="/incoming-upd/:id" element={<IncomingUpdFormPage />} />
        <Route path="/acts" element={<ActsPage />} />
        <Route path="/acts/:id" element={<ActFormPage />} />
        <Route path="/estimates" element={<EstimatesPage />} />
        <Route path="/estimates/:id" element={<EstimateFormPage />} />
        <Route path="/powers-of-attorney" element={<PowersOfAttorneyPage />} />
        <Route path="/powers-of-attorney/:id" element={<PowerOfAttorneyFormPage />} />
      </Route>
      <Route path="/invoices/:id/print" element={<InvoicePrintPage />} />
      <Route path="/upd/:id/print" element={<UpdPrintPage />} />
      <Route path="/acts/:id/print" element={<ActPrintPage />} />
      <Route path="/estimates/:id/print" element={<EstimatePrintPage />} />
      <Route path="/powers-of-attorney/:id/print" element={<PowerOfAttorneyPrintPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
